import React from 'react'

export const NavigateContext = React.createContext(null)
